import { EventEmitter } from '../event-emitter/event-emitter';
import { EventEmitterImpl } from '../event-emitter/impls/event-emitter';
import { RpcImpl } from '../rpc/impls/rpc';
import { DefineRpcMethods, Rpc } from '../rpc/rpc';
import { ExtraPageParams, ModelContext } from '../types';

export const GlobalProxy = Symbol('GlobalProxy');

type GlobalEvents = {
    loaded: void;
}

interface TextParams {
    text: string
}

type RpcHiro = DefineRpcMethods<{
    setCurrentMenu(menu: string): void;
    openSidebar(): Promise<void>;
    closeSidebar(): void;
    newChat(): Promise<void>;

    switchAgent(params: { agentCode: string, createNew?: boolean, taskId?: string, replay?: boolean }): Promise<void>;
    openExtraPage(): void;
    closeExtraPage(): void;
    switchExtraPageContent(params: ExtraPageParams): void;

    setUserMessage(params: {
        input: ModelContext[],
        /** 是否自动发送消息, 默认 false */
        autoSend?: boolean,
        /** 是否创建新会话, 默认 false */
        newChat?: boolean,
        context?: ModelContext[],
        /** 指定 agent 代码, 则为 agent 发送消息, 否则是 chat 发送消息 */
        agentCode?: string,
    }): Promise<void>;

    /**
     * 摘要
     * @deprecated
     */
    summary(params: TextParams): Promise<void>;
    /**
     * 翻译
     */
    translate(params: TextParams): Promise<void>;
}>;

interface NavigateToDetailParams {
    /** 专利 ID */
    patentId: string;
    /** 专利详情页的 tab */
    tab: string;
    [key: string]: any;
}

type RpcHost = DefineRpcMethods<{
    /** 跳转详情 */
    navigateToDetail(params: NavigateToDetailParams): Promise<void>;
}>;

export interface GlobalProxy {
    eventProxy: EventEmitter<GlobalEvents>;
    rpcHiro: Rpc<RpcHiro>;
    rpcHost: Rpc<RpcHost>;
}

export function createGlobalProxy(): GlobalProxy {
    return {
        eventProxy: new EventEmitterImpl<GlobalEvents>(),
        rpcHiro: new RpcImpl<RpcHiro>(),
        rpcHost: new RpcImpl<RpcHost>(),
    };
}
